import xhr from './Xhr';
import {modalHandler} from './Modals';

const sendLink = document.querySelector('.js-modal-mail');
const exerciseSentModal = document.querySelector('#modal-exercise-sent');

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

function sendMail() {
    const sentTitle = sendLink.getAttribute('data-sent-title');
    const url = sendLink.getAttribute('data-mailurl');

    if (url) {
        xhr.get(url).then((request) => {
            const status = JSON.parse(request.status);

            if (status === 200) {
                // IE11 crashes when the modal opens, we couldn't figure out why.
                // This is its fallback.
                if (isIE11) {
                    sendLink.parentNode.innerHTML = `<strong>${sentTitle}</strong>`;
                } else {
                    modalHandler(exerciseSentModal);
                }
            } else {
                // console.log('error');
            }
        });
    }
}

export default function sendExercise() {
    if (sendLink) {
        sendLink.addEventListener('click', (e) => {
            e.preventDefault();

            sendMail();
        });
    }
}



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/SendExercise.js